import acordeon from "../../lib/aria/acordeon";
var desplegables = function () {
    acordeon('.desplegables__opciones', false);
};
export default desplegables;
